<template>
    <div class="list-group border-radius-2 no-border">
        <CheckboxInput
            v-for="role in roles"
            :key="role.id"
            :label="role.name"
            :value="isSelected(role)"
            @input="toggleRole(role)"
            class="list-group-item m-0"
            :class="{ 'px-2 py-1': slim }"
        >
            <template v-slot:label>{{ role.name }}</template>
        </CheckboxInput>

        <CheckboxInput
            v-if="false"
            :label="$t('ad-hoc')"
            :value="adhocEnabled"
            @input="toggleAdhoc"
            class="list-group-item m-0"
            :class="{ 'px-2 py-1': slim }"
        >
            <template v-slot:label>{{ $t('ad-hoc') }}</template>
            <template v-slot:footer>
                <div v-if="adhocEnabled" class="mt-2" @click.stop>
                    <span
                        class="badge badge-secondary badge-sm mr-1 mb-1"
                        v-for="user in adhocUsers"
                        :key="user.id"
                    >
                        {{ user.displayName }}
                        <a style="cursor:pointer" @mousedown.prevent="removeAdhocUser(user)"><b-icon icon="x"></b-icon></a>
                    </span>

                    <div class="position-relative">
                        <input
                            type="search"
                            class="form-control form-control-sm mt-1"
                            :placeholder="$t('search-ellipses')"
                            v-model="searchQuery"
                            @input="filterUsers"
                            @focus="showDropdown = true"
                            @blur="showDropdown = false"
                        />
                        <ul
                            v-if="showDropdown && filteredUsers.length"
                            class="list-group position-absolute w-100"
                            style="z-index:200;max-height:180px;overflow-y:auto;top:100%;"
                        >
                            <li
                                class="list-group-item list-group-item-action py-1"
                                v-for="user in filteredUsers"
                                :key="user.id"
                                @mousedown.prevent="selectAdhocUser(user)"
                            >
                                {{ user.displayName }}
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
        </CheckboxInput>
    </div>
</template>

<script>
import CheckboxInput from '../Inputs/CheckboxInput.vue';

export default {
    components: {
        CheckboxInput,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        slim: {
            type: Boolean,
            default: false,
        },
        adhocUsersValue: {
            type: Array,
            default: () => [],
        },
    },
    mounted() {
        this.roles = this.$config.getValue('roles');
        if (this.adhocUsersValue.length) {
            this.adhocUsers = this.adhocUsersValue.map(u => ({ id: u.user_id, displayName: u.displayName }));
            this.adhocEnabled = true;
        }
    },
    data() {
        return {
            innerValue: this.value,
            roles: [],
            adhocEnabled: false,
            adhocUsers: [],
            allUsers: [],
            filteredUsers: [],
            searchQuery: '',
            showDropdown: false,
            usersFetched: false,
        }
    },
    methods: {
        isSelected(role) {
            return this.innerValue.findIndex(el => el.id == role.id) > -1
        },
        toggleRole(role) {
            const index = this.innerValue.findIndex(el => el.id == role.id)
            if (index > -1) this.innerValue.splice(index, 1)
            else this.innerValue.push(role)

            this.$emit('input', this.innerValue)
        },
        toggleAdhoc(val) {
            this.adhocEnabled = val;
            if (val && !this.usersFetched) {
                this.fetchUsers();
            }
            if (!val) {
                this.adhocUsers = [];
                this.searchQuery = '';
                this.filteredUsers = [];
                this.$emit('adhoc-users', []);
            }
        },
        fetchUsers() {
            this.$cfetch(`${this.$settings.APIBaseURL}/getusers`, { method: 'post' })
                .then(json => {
                    if (json.status && json.status.toLowerCase() === 'success') {
                        this.allUsers = json.teachers || [];
                        this.usersFetched = true;
                    }
                })
                .catch(error => {
                    this.$log.error.call(this, error);
                });
        },
        filterUsers() {
            const q = this.searchQuery.toLowerCase().trim();
            const selectedIds = new Set(this.adhocUsers.map(u => u.id));
            this.filteredUsers = q
                ? this.allUsers.filter(u =>
                    !selectedIds.has(u.id) && u.displayName.toLowerCase().includes(q)
                )
                : [];
            this.showDropdown = true;
        },
        selectAdhocUser(user) {
            this.adhocUsers.push(user);
            this.searchQuery = '';
            this.filteredUsers = [];
            this.showDropdown = false;
            this.$emit('adhoc-users', this.adhocUsers);
        },
        removeAdhocUser(user) {
            const index = this.adhocUsers.findIndex(u => u.id === user.id);
            if (index > -1) {
                this.adhocUsers.splice(index, 1);
                this.$emit('adhoc-users', this.adhocUsers);
            }
        },
    },
    watch: {
        value(newVal) {
            this.innerValue = newVal;
        },
        adhocUsersValue(newVal) {
            if (newVal.length && !this.adhocEnabled) {
                this.adhocUsers = newVal.map(u => ({ id: u.user_id, displayName: u.displayName }));
                this.adhocEnabled = true;
            }
        },
    }
}
</script>
